import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/app-settings';
import { GoogleAuthService } from 'src/app/api/google-auth.service';
import { PlatformService } from 'src/app/api/platform.service';
import { RequestService } from 'src/app/api/request.service';
import { LanguageAware } from 'src/app/general/language-aware';
import { emailValidator } from '../../../components/login-email/login-email.component';
import { LoginService } from '../../../login.service';
@Component({
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
})
export class EmailComponent extends LanguageAware implements OnInit {
  public readonly canShowGoogle = environment.googleLoginSupported;
  public readonly canShowApple = environment.appleLoginSupported && this.ps.isApple();
  public isLoading = false;
  public val = emailValidator.build();
  constructor(
    cdRef: ChangeDetectorRef,
    public login: LoginService,
    private req: RequestService,
    private router: Router,
    public googleAuth: GoogleAuthService,
    private ps: PlatformService
  ) {
    super(cdRef);
  }

  ngOnInit(): void {}

  public async next() {
    if (!(await this.val.validate(this.login))) {
      return;
    }
    this.isLoading = true;
    const res = await this.login.checkEmail(this.login.email).toPromise();
    if (res.result === 'local') {
      if (res.noPassword) {
        this.val.pushError('email', 'NO_PASSWORD');
      }
      this.val.pushError('email', 'LOCAL_USER');
    } else if (res.result === 'disabled') {
      this.val.pushError('email', 'DISABLED_USER');
    } else if (res.result === 'social') {
      switch (res.type) {
        case 'google':
          this.val.pushError('email', 'SOCIAL_GOOGLE');
          break;
        default:
          this.val.pushError('email', 'SOCIAL');
          break;
      }
    } else if (res.result === 'no_user') {
      // Fallthrough
    } else {
      this.val.pushError('email', this.trans('general.unknownError'));
      this.isLoading = false;
      throw new Error('Unknown result: ' + (res as any).result);
    }
    if ( res.result !== 'no_user' ) {
      this.isLoading = false;
      return;
    }
    const resReg = await this.req.login.register(this.login.email).toPromise();
    this.isLoading = false;
    if (resReg.success === false) {
      this.val.pushError('email', resReg.error);
      return;
    }
    this.login.activationToken = resReg.activation_token;
    this.router.navigate(['login', 'register', 'code'], { replaceUrl: true });
  }
}
